import { Divider, Stack } from "@mui/material"
import type React from "react"
import { extraColors } from "../../utils/theme"
import { MainContent } from "../MainContent"
import { PageContainer } from "../PageContainer"
import { AlertCandidates } from "./AlertCandidates"
import { PotentialAlerts } from "./PotentialAlerts"

export const AlertCuration: React.FC = () => {
  return (
    <MainContent headerProps={{ title: "Biothreat Signals" }} disableLeftGutter>
      <PageContainer sx={{ minHeight: "calc(100vh - 100px)", marginBottom: 0 }}>
        <Stack spacing={2} sx={{ pt: 2, height: "100%" }}>
          <PotentialAlerts />

          <Divider
            sx={{
              borderColor: extraColors.translucent8,
              borderStyle: "dashed",
            }}
          />

          <AlertCandidates />
        </Stack>
      </PageContainer>
    </MainContent>
  )
}
